import {AppBar, Toolbar} from '@mui/material';
import classnames from 'classnames';
import React from 'react';
import {isEmpty} from 'lodash';
import Icon from 'shared/components/icon';
import UnstyledButton from 'src/components/unstyled-button';
import NavbarLogo from '../NavbarLogo';
import styles from './styles.module.scss';
import LeadGenerationLogo from '../lead-generation-logo/lead-genreation-logo';
import useFeatureFlags from 'src/hooks/useFeatureFlags';

interface MobileNavbarProps {
  routed?: boolean | undefined;
  onDrawerToggle: () => void;
  isCollegePortal?: boolean;
}

const MobileNavbar = ({
  routed = true,
  onDrawerToggle,
  isCollegePortal = false,
}: MobileNavbarProps) => {
  const flags = useFeatureFlags(['leadGenerationLogoFlag']);
  const flagsLoaded = !isEmpty(flags);

  return (
    <AppBar position="static" className={classnames('toolbar', styles.appBar)}>
      <Toolbar>
        {isCollegePortal && !flagsLoaded ? null : flags.leadGenerationLogoFlag &&
          isCollegePortal ? (
          <div className={styles.logo}>
            <LeadGenerationLogo />
          </div>
        ) : (
          <div className={styles.logo}>
            <NavbarLogo routed={routed} />
          </div>
        )}
        <UnstyledButton onClick={onDrawerToggle} className={styles.mobileBarsButton}>
          <Icon iconType="bars" />
        </UnstyledButton>
      </Toolbar>
    </AppBar>
  );
};

export default MobileNavbar;
